import { computed, flow, makeObservable, observable } from 'mobx'

import { requestWrapper } from 'Shared/utils'

import { ALL_OPTION } from 'Core/constants'
import { CustomGenerator } from 'Core/interfaces'
import { entityToStringLabelValue, getDefaultStoreArrayValue } from 'Core/utils'
import { formatDataToLabelValue } from 'Core/utils'

import { MetadataRepo } from 'Portals/Supplier/repositories'
import { RootStore } from 'Portals/Supplier/stores'

// Order of languages in DB doesn't correspond to order in requirements
export const ORDERED_LANGUAGES = [
	'English',
	'Spanish',
	'Turkish',
	'Portuguese',
	'Chinese - Mandarin'
]

export class MetadataStore {
	@observable accessor languages = getDefaultStoreArrayValue<Entity>()
	@observable accessor supplierLocations = getDefaultStoreArrayValue()

	constructor(public rootStore: RootStore) {
	}

	@computed
	get languageOptions() {
		return formatDataToLabelValue(this.languages.value)
	}

	@computed
	get supplierLocationsAllOptions() {
		return [ALL_OPTION, ...this.supplierLocations.value.map(entityToStringLabelValue)]
	}

	@flow.bound
	*retrieveSupplierLocations() {
		yield requestWrapper({
			field: this.supplierLocations,
			repository: MetadataRepo.retrieveSupplierLocations,
			repositoryParams: null
		})
	}

	@flow.bound
	*retrieveLanguages(): CustomGenerator<Entity[]> {
		const data = yield requestWrapper({
			field: this.languages,
			repository: MetadataRepo.retrieveLanguages,
			repositoryParams: null
		})

		data.sort((a, b) => ORDERED_LANGUAGES.indexOf(a.name) - ORDERED_LANGUAGES.indexOf(b.name))

		this.languages.value = data
	}
}
